import LFCSelectForm from '_components/inputs/LFCSelectForm';
import {getLFCData} from '_logics/LFCUtil';
import axios, {CancelTokenSource} from 'axios';
import {useSnackbar} from 'notistack';
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {SelectChangeEvent} from '@mui/material';

interface Props {
  name: string;
  label?: string;
  value: any;
  onChange: ((event: SelectChangeEvent<any>, child: React.ReactNode) => void) | undefined;
  style?: any;
  fullWidth?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  margin?: 'dense' | 'normal' | 'none';
  required?: boolean;
  size?: 'small' | 'medium';
  multiple?: boolean;
  // selectItem: any;
  // id: string;
}

/**
 * 機種プルダウン
 * @param props
 * @returns
 */
const LFCSelectFormMap = React.memo((props: Props) => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const cancelSource = useRef<CancelTokenSource | null>(null);

  const [items, setItems] = useState<{name: string; value?: string}[]>([{name: t('すべて')}]);

  useEffect(() => {
    // マウント時処理
    if (cancelSource.current) cancelSource.current.cancel('req cancel');

    cancelSource.current = axios.CancelToken.source();
    // 機種情報取得
    getLFCData({
      snack: enqueueSnackbar,
      sql_id: 18,
      parameters: {},
      cancelToken: cancelSource.current.token,
      t
    }).then((data: any) => {
      const tmp: any = data.map((item: any) => {
        return {name: item['map']};
      });
      tmp.unshift({name: t('すべて'), value: `${t('すべて')}`});
      setItems(tmp);
    });

    return () => {
      // アンマウント処理
      if (cancelSource.current) cancelSource.current.cancel('req cancel');
    };
  }, []);

  return (
    <LFCSelectForm
      name={props.name}
      label={props.label ? props.label : t('検査部位')}
      value={props.value !== undefined ? props.value : t('すべて')}
      onChange={props.onChange}
      style={props.style}
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      autoFocus={props.autoFocus}
      margin={props.margin}
      required={props.required}
      size={props.size}
      multiple={props.multiple}
      selectItem={items}
      id={'sf_map'}
    />
  );
});
export default LFCSelectFormMap;
